import { ChainId } from '@ui/types/chain';
import { BareTradePair } from '@ui/types/tradePair';
import { Nullable } from 'vitest';

import { tradeHistoryControllerApi } from '../../clients/clients';
import { GetHistoryRequest } from '../../generated';
import { toServerBlockChain } from '../../utils';
import { toTradeHistoryResponse } from './toTradeHistory';

export type TradeHistoryParam = {
  userAddress: Nullable<GetHistoryRequest['userAddress']>;
  page: number;
  size: number;
};

const getKey = (
  params: TradeHistoryParam & {
    chainId: ChainId;
  },
) => {
  return ['tradeHistoryControllerApi', params];
};
const getFn =
  ({
    chainId,
    pairs,
    ...params
  }: TradeHistoryParam & {
    chainId: ChainId;
    pairs: BareTradePair[];
  }) =>
  async () => {
    if (!params.userAddress) {
      throw new Error('Query should not be called');
    }

    const rawResponse = await tradeHistoryControllerApi.getHistory({
      userAddress: params.userAddress,
      page: params.page,
      size: params.size,
      blockChain: toServerBlockChain(chainId),
    });

    return toTradeHistoryResponse(
      rawResponse,
      params.page,
      params.size,
      chainId,
      pairs,
    );
  };
export const tradeHistoryQuery = {
  getKey,
  getFn,
};
